<sh-form-group
    [invalid]="isControlInvalid$ | async"
    [required]="isControlRequired$ | async"
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [currentActionItems]="currentActionItems"
    [describeLabelId]="describeLabelId"
    [errorMsg]="errorMsg"
    [id]="controlId"
    [formGroupStyling]="formGroupStyling"
>
    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>

    <ng-container *ngIf="canBeIndeterminate; then complex; else simple"> </ng-container>

    <ng-template #complex>
        <sh-form-textarea-complex-base
            [formControl]="control"
            [id]="controlId"
            [invalid]="isControlInvalid$ | async"
            [autocomplete]="autocomplete"
            [resizable]="resizable"
            [rows]="rows"
            [placeholder]="placeholder"
            [describeLabelId]="describeLabelId"
            class="sh-form-group__input"
            [indeterminateMsg]="indeterminateMsg"
            [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
        >
        </sh-form-textarea-complex-base>
    </ng-template>
    <ng-template #simple>
        <sh-form-textarea-base
            [formControl]="control"
            [id]="controlId"
            [invalid]="isControlInvalid$ | async"
            [autocomplete]="autocomplete"
            [resizable]="resizable"
            [rows]="rows"
            [placeholder]="placeholder"
            [describeLabelId]="describeLabelId"
            class="sh-form-group__input"
            [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
        >
        </sh-form-textarea-base>
    </ng-template>
</sh-form-group>
